export const fieldsToRemove = [
  'catalogId',
  'discountOnlyOnSum',
  'finalDiscount',
  'finalValue',
  'finalValueWithTaxes',
  'isToUseDiscountOnTotalValue',
  'productItems',
  'products',
  'taxes'
];
